// Single place to open a master suite's read-only View page, so the library grid
// and the Scheduled Runs page navigate identically.
export const goToMasterSuiteView = (navigate, name, defaultEnvironment) =>
  navigate(`/mastersuite/view/${encodeURIComponent(name)}`, {
    state: { defaultEnvironment },
  });
